module.exports = __webpack_public_path__ + "static/images/abef5c3d.png";